
      import API from "!../../../../../bundler/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../../../bundler/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../../../bundler/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../../../bundler/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../../../bundler/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../../../bundler/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../../../bundler/node_modules/css-loader/dist/cjs.js!./GlobalStyles.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;
options.insert = insertFn.bind(null, "head");
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../../../../bundler/node_modules/css-loader/dist/cjs.js!./GlobalStyles.css";
       export default content && content.locals ? content.locals : undefined;
